import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
} from "antd";
import React, { useState } from "react";
import { Content } from "antd/es/layout/layout";
import "./style.css";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
const { TextArea } = Input;

const Seller = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [secBuyer, setSecBuyer] = useState(false);
  const [secSeller, setSecSeller] = useState(false);
  const [waiveMortgage, setWaiveMortgage] = useState(false);
  const [waiveinspection, setWaiveinspection] = useState(false);
  const [escalation, setEsclation] = useState(false);
  const [representation, setRepresentation] = useState(false);
  const [paymentOfEscalatedPrice, setPaymentOfEscalatedPrice] = useState(null);
  const [offDeposit, setOffDeposit] = useState(null);
  const [compensation, setCompensation] = useState(null);
  const [agentFee, setAgentFee] = useState("percentage");
  const [nonAgentFee, setNonAgentFee] = useState("percentage");
  const [totalCommission, setTotalCommission] = useState("percentage");
  const [reportingDevice, setReportingDevice] = useState("does");
  const [brokerFee, setBrokerFee] = useState("percentage");
  const [buyerBrokerFee, setBuyerBrokerFee] = useState(null);

  const [date, setDate] = useState(moment().set({ hour: 12, minute: 0 })); // Default to 12 PM

  const onHandleSubmit = async (values) => {
    values.waiveMortgage = waiveMortgage;
    values.waiveinspection = waiveinspection;
    values.paymentOfEscalatedPrice = paymentOfEscalatedPrice;
    console.log(values);
    // let res = await api.post("/formValues", values);
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/seller-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    debugger;

    console.log(res);
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Seller Form"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Content style={{ height: "100vh", padding: "12px" }}>
      <div className="main">
        <Form
          className="signup-form"
          onFinish={onHandleSubmit}
          form={form}
          layout="vertical"
          name="offerForm"
        >
          <div className="fieldMain">
            <div className={`field ${secSeller ? "" : "mtMinus"}`}>
              <div>
                <div className="plusHeader">
                  {!secSeller && (
                    <div className="plus" onClick={() => setSecSeller(true)}>
                      +
                    </div>
                  )}

                  <label className="form-title" for="sellerName">
                    Seller(s) Full Name
                  </label>
                </div>
                <Form.Item
                  name="sellerName"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secSeller && (
                <Form.Item
                  name="sellerName2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Full Name"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
            <div className="field">
              <div>
                <label className="form-title" for="sellerAddress">
                  Seller(s) Address
                </label>
                <Form.Item
                  name="sellerAddress"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              {secSeller && (
                <Form.Item
                  name="sellerAddress2"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Address"
                    autoComplete="off"
                  />
                </Form.Item>
              )}
            </div>
          </div>
          <hr />

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="agentFullName">
                Agent Full Name
              </label>
              <Form.Item
                name="agentFullName"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentLicenseNumber">
                Agent License Number
              </label>
              <Form.Item
                name="agentLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter License Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="agentBrokerage">
                Agent Brokerage
              </label>
              <Form.Item
                name="agentBrokerage"
                rules={[{ required: true, message: "required!" }]}
                initialValue={"Vicente Realty, LLC"}
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled={true}
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="brokerageLicenseNumber">
                Brokerage License Number
              </label>
              <Form.Item
                name="brokerageLicenseNumber"
                rules={[{ required: true, message: "required!" }]}
                initialValue="9799"
              >
                <Input
                  className="input"
                  // placeholder="Enter address"
                  autoComplete="off"
                  disabled
                />
              </Form.Item>
            </div>
          </div>

          <div className="radioMain">
            <Form.Item
              // label="radio"
              name="radio1"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Broker"
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
                defaultValue="Broker"
              >
                <Radio value="Salesperson">Salesperson</Radio>
                <Radio value="Broker">Broker</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio2"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Designated Agency"
            >
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  columnGap: "1rem",
                }}
                defaultValue="Designated Agency"
              >
                <Radio value="Non-Designated Agency">
                  Non-Designated Agency
                </Radio>
                <Radio value="Designated Agency">Designated Agency</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              // label="radio"
              name="radio3"
              rules={[{ required: true, message: "required!" }]}
              initialValue="Seller's agent"
            >
              <Radio.Group defaultValue="Seller's agent">
                <Radio value="Seller's agent">Seller's Agent</Radio>
                <Radio value="Facilitator">Facilitator</Radio>
                <Radio value="Dual agent">Dual Agent</Radio>
              </Radio.Group>
            </Form.Item>
          </div>

          <hr />

          <div>
            <label className="form-title" for="propertyAddress">
              Property Address
            </label>
            <Form.Item
              name="propertyAddress"
              rules={[{ required: true, message: "required!" }]}
            >
              <TextArea
                className="input"
                placeholder="Enter Property Address"
                autoComplete="off"
              />
            </Form.Item>
          </div>
          <hr />

          <div className="fieldMain">
            <div className="field">
              <label htmlFor="countyRegistry">County Registry</label>
              <Form.Item
                name="countyRegistry"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Country Registry"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label htmlFor="bookNumber">Book Number</label>
              <Form.Item
                name="bookNumber"
                // rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Book Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label htmlFor="pageNumber">Page Number</label>
              <Form.Item
                name="pageNumber"
                // rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Page Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            {/* <div className="field">
              <label htmlFor="certificateNumber">Certificate Number</label>
              <Form.Item
                name="certificateNumber"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Certificate Number"
                  autoComplete="off"
                />
              </Form.Item>
            </div> */}
          </div>

          <div>
            <div>
              <label className="form-title" for="Recording Devices on Premises">
                Recording Devices on Premises
              </label>
              <Form.Item
                name="reportingDevices"
                rules={[{ required: true, message: "required!" }]}
                initialValue="does"
              >
                <Radio.Group
                  onChange={(e) => setReportingDevice(e.target.value)}
                  defaultValue="does"
                >
                  <Radio value="does">Does</Radio>
                  <Radio value="doesNot">Does Not</Radio>
                </Radio.Group>
              </Form.Item>
            </div>

            {reportingDevice == "does" && (
              <div>
                <Form.Item
                  name="reportingDevicesPoint"
                  rules={[{ required: true, message: "required!" }]}
                  initialValue="both"
                >
                  <Radio.Group defaultValue="both">
                    <Radio value="audio">Audio</Radio>
                    <Radio value="video">Video</Radio>
                    <Radio value="both">Both</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            )}
          </div>

          <div className="fieldMain">
            <div className="field">
              <label className="form-title" for="Listing Price">
                Listing Price
              </label>
              <Form.Item
                name="listingPrice"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Listing Price"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="Listing Start Period">
                Listing Start Period
              </label>
              <Form.Item
                name="listingStartPeriod"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  placeholder={"Select date"}
                  format="MM-DD-YYYY"
                />
              </Form.Item>
            </div>
            <div className="field">
              <label className="form-title" for="Listing End Period">
                Listing End Period
              </label>
              <Form.Item
                name="listingEndPeriod"
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker
                  inputReadOnly
                  placeholder={"Select date"}
                  format="MM-DD-YYYY"
                />
              </Form.Item>
            </div>
          </div>

          <hr />

          <div style={{ display: "flex", columnGap: "1rem" }}>
            <div>
              <label className="form-title" for="Listing Broker's Fee">
                Listing Broker's Fee
              </label>
              <Form.Item
                name="listingBrokerType"
                rules={[{ required: true, message: "required!" }]}
                initialValue="percentage"
              >
                <Radio.Group
                  onChange={(e) => setBrokerFee(e.target.value)}
                  defaultValue="percentage"
                >
                  <Radio value="percentage">Percentage</Radio>
                  {/* <Radio value="flatFee">Flat Fee</Radio> */}
                </Radio.Group>
              </Form.Item>
            </div>

            {brokerFee == "percentage" ? (
              <div className="field">
                <label htmlFor="percentage">Percentage</label>
                <Form.Item
                  name="listingBrokerFee"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Percentage Number"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
            ) : brokerFee == "flatFee" ? (
              <div className="field">
                <label htmlFor="flatFee">Flat Fee</label>
                <Form.Item
                  name="listingBrokerFee"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    className="input"
                    placeholder="Enter Flat Fee"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
            ) : null}
          </div>

          <hr />

          <div>
            <label className="form-title" for="Buyer Broker's Fee">
              Buyer Broker's Fee
            </label>
            <Form.Item
              name="buyerBrokerFeeAgreement"
              rules={[{ required: true, message: "required!" }]}
              initialValue="agree"
            >
              <Radio.Group
                onChange={(e) => setBuyerBrokerFee(e.target.value)}
                defaultValue="agree"
              >
                <Radio value="agree">
                  The Seller(s) hereby authorizes and agree that the Listing
                  Broker may offer compensation to the Buyer Broker.
                </Radio>
                <Radio value="notAgree">
                  Seller(s) DOES NOT authorize nor agree to have LISTING BROKER
                  offer a Buyer Broker's Fee.
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>

          <div style={{ display: "flex", columnGap: "2rem" }}>
            <div>
              <label htmlFor="Agent">Agent</label>
              <div style={{ display: "flex", columnGap: "5px" }}>
                <div>
                  <Form.Item
                    name="agent"
                    rules={[{ required: true, message: "required!" }]}
                    initialValue="percentage"
                  >
                    <Radio.Group
                      onChange={(e) => setAgentFee(e.target.value)}
                      style={{ display: "flex", flexDirection: "column" }}
                      defaultValue="percentage"
                    >
                      <Radio value="percentage">Percentage</Radio>
                      {/* <Radio value="flatFee">Flat Fee</Radio> */}
                    </Radio.Group>
                  </Form.Item>
                </div>

                {agentFee == "percentage" ? (
                  <div>
                    <Form.Item
                      name="agentFee"
                      rules={[{ required: true, message: "required!" }]}
                    >
                      <Input placeholder="Enter Percentage" />
                    </Form.Item>
                    <Form.Item
                      name="agentPercentagePoint"
                      rules={[{ required: true, message: "required!" }]}
                      initialValue="net"
                    >
                      <Radio.Group defaultValue="net">
                        <Radio value="net">Net</Radio>
                        <Radio value="gross">Gross</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                ) : agentFee == "flatFee" ? (
                  <Form.Item
                    name="agentFee"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input placeholder="Enter Flat Fee" />
                  </Form.Item>
                ) : null}
              </div>
            </div>
            <div>
              <label htmlFor="Agent">Facilitators</label>
              <div style={{ display: "flex", columnGap: "5px" }}>
                <div>
                  <Form.Item
                    name="Facilitators"
                    rules={[{ required: true, message: "required!" }]}
                    initialValue="percentage"
                  >
                    <Radio.Group
                      onChange={(e) => setNonAgentFee(e.target.value)}
                      style={{ display: "flex", flexDirection: "column" }}
                      defaultValue="percentage"
                    >
                      <Radio value="percentage">Percentage</Radio>
                      {/* <Radio value="flatFee">Flat Fee</Radio> */}
                    </Radio.Group>
                  </Form.Item>
                </div>

                {nonAgentFee == "percentage" ? (
                  <div>
                    <Form.Item
                      name="nonAgentFee"
                      rules={[{ required: true, message: "required!" }]}
                    >
                      <Input placeholder="Enter Percentage" />
                    </Form.Item>
                    <Form.Item
                      name="nonAgentPercentagePoint"
                      rules={[{ required: true, message: "required!" }]}
                      initialValue="net"
                    >
                      <Radio.Group defaultValue="net">
                        <Radio value="net">Net</Radio>
                        <Radio value="gross">Gross</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                ) : nonAgentFee == "flatFee" ? (
                  <Form.Item
                    name="nonAgentFee"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input placeholder="Enter Flat Fee" />
                  </Form.Item>
                ) : null}
              </div>
            </div>
            <div>
              <label htmlFor="Agent">Total Commission</label>
              <div style={{ display: "flex", columnGap: "5px" }}>
                <div>
                  <Form.Item
                    name="toalCommission"
                    rules={[{ required: true, message: "required!" }]}
                    initialValue="percentage"
                  >
                    <Radio.Group
                      onChange={(e) => setTotalCommission(e.target.value)}
                      style={{ display: "flex", flexDirection: "column" }}
                      defaultValue="percentage"
                    >
                      <Radio value="percentage">Percentage</Radio>
                      {/* <Radio value="flatFee">Flat Fee</Radio> */}
                    </Radio.Group>
                  </Form.Item>
                </div>

                {totalCommission == "percentage" ? (
                  <div>
                    <Form.Item
                      name="totalCommissionFee"
                      rules={[{ required: true, message: "required!" }]}
                    >
                      <Input placeholder="Enter Percentage" />
                    </Form.Item>
                    <Form.Item
                      name="totalCommissionPoint"
                      rules={[{ required: true, message: "required!" }]}
                      initialValue={"net"}
                    >
                      <Radio.Group defaultValue="net">
                        <Radio value="net">Net</Radio>
                        <Radio value="gross">Gross</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                ) : totalCommission == "flatFee" ? (
                  <Form.Item
                    name="totalCommissionFee"
                    rules={[{ required: true, message: "required!" }]}
                  >
                    <Input placeholder="Enter Flat Fee" />
                  </Form.Item>
                ) : null}
              </div>
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <label className="form-title" for="additionalTerms">
              Additional terms
            </label>
            <Form.Item
              name="additionalTerms"
              rules={[{ required: true, message: "required!" }]}
            >
              <TextArea
                rows={2}
                placeholder="Additional terms"
                style={{ marginTop: "0.5rem" }}
              />
            </Form.Item>
          </div>

          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </div>
    </Content>
  );
};

export default Seller;
